import { DEFAULT_HOME_PAGE, PermissionKey, ROLE_PERMISSIONS } from '@/constants';
import { AuthAction, Module, Role, SubModule } from '@/enums';

export interface PermissionMetadata {
  module: Module;
  subModule: SubModule;
  action: AuthAction;
}

// Returns true if any of the supplied roles grants the given permission.
// Deny-by-default: unknown roles, missing entries, and wrong module/sub combos all fail.
export const hasPermission = (roles: readonly Role[], check: PermissionMetadata): boolean => {
  const key: PermissionKey = `${check.module}.${check.subModule}.${check.action}`;
  return roles.some((role) => {
    const perms = ROLE_PERMISSIONS[role as Role];
    return perms ? (perms as readonly string[]).includes(key) : false;
  });
};

export const getUserDefaultHomePage = (roles: readonly Role[]): string => {
  // loop through DEFAULT_HOME_PAGE and return the first one that matches the user's roles
  // this lets us declare the roles in the order of priority
  const matched = Object.entries(DEFAULT_HOME_PAGE).find(([roleKey]) =>
    roles.includes(roleKey as Role),
  );
  return matched?.[1] ?? DEFAULT_HOME_PAGE[Role.Unknown];
};
